import Flickity from 'flickity'

const loadLocationTour = () => {
    const locationTour = document.querySelector('.location-tour')

    if (locationTour) {
        new Flickity(locationTour, { // eslint-disable-line no-new
            adaptiveHeight: true,
            contain: true,
            imagesLoaded: true,
            pageDots: false,
            wrapAround: true
        })
    }
}

export default loadLocationTour



// WEBPACK FOOTER //
// ./js/locationTour.js